<template>
<div class="box-page">
    <div class="page-header with-underline">
        <div class="d-flex align-items-center justify-content-center">
            <span class="page-title">ตั้งค่า</span>
        </div>
    </div>
    <div class="container">
        <div class="page-sub-header with-underline">
            <div class="box-subtitle">
                <div class="title">
                    <span>ค่าธรรมเนียมการทำสัญญา</span>
                </div>
                <div class="desc">
                    <span></span>
                </div>
            </div>
            <div class="right-of-header">
                <div class="d-flex">
                    <div class="ele-checkmark d-inline-block" :class="fee.contract.is_percent ? '' : 'is-active'"
                    @click="selectValueType('contract', false)">
                        <div class="ele-checkmark-checkbox">
                            <i class="fa fa-check"></i>
                        </div>
                    </div>
                    <div class="ele-textbox d-inline-block">
                        <input type="text" class="ele-textbox-input" placeholder="จำนวนเงิน" v-model="fee.contract.value" maxlength="8"
                        @keypress="validateDecimalKeyPress($event)"/>
                    </div>
                    <span class="ml-2">บาท</span>
                </div>
                <div class="d-flex">
                    <div class="ele-checkmark d-inline-block" :class="fee.contract.is_percent ? 'is-active' : ''"
                    @click="selectValueType('contract', true)">
                        <div class="ele-checkmark-checkbox">
                            <i class="fa fa-check"></i>
                        </div>
                    </div>
                    <div class="ele-textbox d-inline-block">
                        <input type="text" class="ele-textbox-input" placeholder="เปอร์เซ็น" v-model="fee.contract.percent_value" maxlength="5"
                        @keypress="validateDecimalKeyPress($event)"/>
                    </div>
                    <span class="ml-2">%</span>
                </div>
            </div>
        </div>
        <div class="page-sub-header with-underline">
            <div class="box-subtitle">
                <div class="title">
                    <span>ค่าธรรมเนียมการทำสัญญาสินเชื่อบ้าน</span>
                </div>
                <div class="desc">
                    <span></span>
                </div>
            </div>
            <div class="right-of-header">
                <div class="d-flex">
                    <div class="ele-checkmark d-inline-block" :class="fee.contract_mortgage.is_percent ? '' : 'is-active'"
                    @click="selectValueType('contract_mortgage', false)">
                        <div class="ele-checkmark-checkbox">
                            <i class="fa fa-check"></i>
                        </div>
                    </div>
                    <div class="ele-textbox d-inline-block">
                        <input type="text" class="ele-textbox-input" placeholder="จำนวนเงิน" v-model="fee.contract_mortgage.value" maxlength="8"
                        @keypress="validateDecimalKeyPress($event)"/>
                    </div>
                    <span class="ml-2">บาท</span>
                </div>
                <div class="d-flex">
                    <div class="ele-checkmark d-inline-block" :class="fee.contract_mortgage.is_percent ? 'is-active' : ''"
                    @click="selectValueType('contract_mortgage', true)">
                        <div class="ele-checkmark-checkbox">
                            <i class="fa fa-check"></i>
                        </div>
                    </div>
                    <div class="ele-textbox d-inline-block">
                        <input type="text" class="ele-textbox-input" placeholder="เปอร์เซ็น" v-model="fee.contract_mortgage.percent_value" maxlength="5"
                        @keypress="validateDecimalKeyPress($event)"/>
                    </div>
                    <span class="ml-2">%</span>
                </div>
            </div>
        </div>
        <div class="page-sub-header with-underline">
            <div class="box-subtitle">
                <div class="title">
                    <span>ค่าถอนเงิน</span>
                </div>
                <div class="desc">
                    <span></span>
                </div>
            </div>
            <div class="right-of-header">
                <div class="d-flex">
                    <div class="ele-checkmark d-inline-block" :class="fee.withdraw.is_percent ? '' : 'is-active'"
                    @click="selectValueType('withdraw', false)">
                        <div class="ele-checkmark-checkbox">
                            <i class="fa fa-check"></i>
                        </div>
                    </div>
                    <div class="ele-textbox d-inline-block">
                        <input type="text" class="ele-textbox-input" placeholder="จำนวนเงิน" v-model="fee.withdraw.value" maxlength="8"
                        @keypress="validateDecimalKeyPress($event)"/>
                    </div>
                    <span class="ml-2">บาท</span>
                </div>
                <div class="d-flex">
                    <div class="ele-checkmark d-inline-block" :class="fee.withdraw.is_percent ? 'is-active' : ''"
                    @click="selectValueType('withdraw', true)">
                        <div class="ele-checkmark-checkbox">
                            <i class="fa fa-check"></i>
                        </div>
                    </div>
                    <div class="ele-textbox d-inline-block">
                        <input type="text" class="ele-textbox-input" placeholder="เปอร์เซ็น" v-model="fee.withdraw.percent_value" maxlength="5"
                        @keypress="validateDecimalKeyPress($event)"/>
                    </div>
                    <span class="ml-2">%</span>
                </div>
            </div>
        </div>
        <div class="page-sub-header with-underline">
            <div class="box-subtitle">
                <div class="title">
                    <span>ค่าธรรมเนียมดูเครดิตประวัติการชำระเงิน</span>
                </div>
                <div class="desc">
                    <span></span>
                </div>
            </div>
            <div class="right-of-header">
                <div class="d-flex">
                    <div class="ele-checkmark is-active d-inline-block">
                        <div class="ele-checkmark-checkbox">
                            <i class="fa fa-check"></i>
                        </div>
                    </div>
                    <div class="ele-textbox d-inline-block">
                        <input type="text" class="ele-textbox-input" placeholder="จำนวนเงิน" v-model="fee.pay_history.value" maxlength="8"
                        @keypress="validateDecimalKeyPress($event)"/>
                    </div>
                    <span class="ml-2">บาท</span>
                </div>
            </div>
        </div>
        <div class="page-sub-header with-underline">
            <div class="box-subtitle">
                <div class="title">
                    <span>ค่ารักษาบัญชีรายปี</span>
                </div>
                <div class="desc">
                    <span></span>
                </div>
            </div>
            <div class="right-of-header">
                <div class="d-flex">
                    <div class="ele-checkmark is-active d-inline-block">
                        <div class="ele-checkmark-checkbox">
                            <i class="fa fa-check"></i>
                        </div>
                    </div>
                    <div class="ele-textbox d-inline-block">
                        <input type="text" class="ele-textbox-input" placeholder="จำนวนเงิน" v-model="fee.annual.value" maxlength="8"
                        @keypress="validateDecimalKeyPress($event)"/>
                    </div>
                    <span class="ml-2">บาท</span>
                </div>
            </div>
        </div>
        <div class="page-sub-header with-underline">
            <div class="box-subtitle">
                <div class="title">
                    <span>ตั้งค่า Limit การทำสัญญา</span>
                </div>
                <div class="desc">
                    <span></span>
                </div>
            </div>
            <div class="right-of-header">
                <div class="d-flex">
                    <div class="ele-checkmark is-active d-inline-block">
                        <div class="ele-checkmark-checkbox">
                            <i class="fa fa-check"></i>
                        </div>
                    </div>
                    <div class="ele-textbox">
                        <input type="text" class="ele-textbox-input" placeholder="จำนวน" v-model="fee.limit_contract.value" maxlength="2"
                        @keypress="validateIntKeyPress($event)"/>
                    </div>
                    <span class="ml-2">ต่อวัน</span>
                </div>
            </div>
        </div>
    </div>
    <div class="text-center mt-3">
        <button class="btn btn-small" @click="updateSettings" :disabled="disabledBtn">ยืนยัน</button>
        <button class="btn btn-small" @click="loadSettings" :disabled="disabledBtn">ย้อนกลับ</button>
    </div>
</div>
</template>

<script>
    import ShareFunction from '../../share-function';
    export default {
        data: function () {
            return {
                baseUrl: window.BASE_URL,
                fee: {
                    lender_fee: { code: '', value: '', percent_value: '', is_percent: false },
                    contract: { code: '', value: '', percent_value: '', is_percent: false },
                    contract_mortgage: { code: '', value: '', percent_value: '', is_percent: false },
                    deposit: { code: '', value: '', percent_value: '', is_percent: false },
                    withdraw: { code: '', value: '', percent_value: '', is_percent: false },
                    annual: { code: '', value: '', percent_value: '' },
                    pay_history: { code: '', value: '' },
                    limit_contract: { code: '', value: '' },
                },
                disabledBtn: false,
            }
        },
        mounted() {
        },
        created() {
            this.loadSettings();
        },
        computed: {
        },
        methods: {
            validateDecimalKeyPress(evt) {
                return ShareFunction.validateDecimalKeyPress(evt.target, evt);
            },
            validateIntKeyPress(evt) {
                return ShareFunction.isNumberKey(evt);
            },
            loadSettings(id) {
                axios.get(`${this.baseUrl}/admin/setting/api/get`).then(({ data }) => {
                    if (data != null && data.data) {
                        const d = data.data;
                        console.log('d', d);
                        this.fee = d;
                    }
                });
            },
            updateSettings() {
                this.disabledBtn = true;
                const params = {
                    data: []
                };
                const keyOfFee = Object.keys(this.fee);
                keyOfFee.forEach(item => {
                    params.data.push({
                        code: this.fee[item].code,
                        value: this.fee[item].value,
                        percent_value: this.fee[item].percent_value,
                        is_percent: this.fee[item].is_percent,
                    });
                });
                $.confirmbox({
                    title: 'ยืนยัน',
                    msg: 'บันทึกข้อมูลใช่หรือไม่ ?',
                    confirmEvent: () => {
                        axios.post(`${this.baseUrl}/admin/setting/api/update`, params).then(({ data }) => {
                            if (data != null && data.success) {
                                alertbox('บันทึกสำเร็จ');
                                this.loadSettings();
                            }
                        });
                    }
                });
                setTimeout(() => {
                    this.disabledBtn = false;
                }, 1000);
            },
            selectValueType(feeType, isPercent) {
                this.fee[feeType].is_percent = isPercent;
            },
        },
        props: {
        },
        components: {
        },
    }
</script>

<style lang="scss" scoped>
    .ele-textbox {
        width: 100px;
        .ele-textbox-input {
            padding-top: 0;
            text-align: right;
        }
    }
    .page-sub-header {
        position: relative;
        width: 100%;
        min-height: 1px;
        display: flex;
        justify-content: space-between;
    }

</style>



